import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Params, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { StructureListEntryDto } from '@coin/importer/dto/util';
import { PopupAction } from '@coin/importer/core/util';
import { SimpleTableHeader } from '../../simple-table/simple-table.component';
import { StructureListService } from '../../../services/organisation-management/structure-list.service';
import { StructureListEntryPopupComponent } from '../structure-list-entry-popup/structure-list-entry-popup.component';

@Component({
  selector: 'ci-structure_list',
  templateUrl: './structure_list.component.html',
  styleUrls: ['./structure_list.component.scss'],
  standalone: false
})
export class StructureListComponent {
  structureListService = inject(StructureListService);
  private route = inject(ActivatedRoute);
  private matDialog = inject(MatDialog);

  public entryList: StructureListEntryDto[];
  public queryParameters$: Observable<Params> = this.route.queryParamMap;
  public updaterIntervalInMs = null;
  public selectedTableHeaders: SimpleTableHeader[] = [
    {
      title: 'Edit',
      width: '50px'
    },
    {
      title: 'Delete',
      width: '50px'
    },
    {
      title: 'Target Org Code',
      key: 'TargetOrgCode',
      filterType: 'input'
    },
    {
      title: 'Position',
      key: 'Position',
      filterType: 'input'
    },
    {
      title: 'HeadGid',
      key: 'HeadGid',
      filterType: 'input'
    },
    {
      title: 'Acting'
    },
    {
      title: 'Created at',
      key: 'CreatedAt',
      filterType: 'date'
    },
    {
      title: 'Created by Gid',
      key: 'CreatedByGid',
      filterType: 'input'
    },
    {
      title: 'Last modified at',
      key: 'LastModifiedAt',
      filterType: 'date'
    },
    {
      title: 'Last modified by Gid',
      key: 'LastModifiedByGid',
      filterType: 'input'
    }
  ];

  openCreateStructureListEntryPopup(): void {
    this.matDialog.open(StructureListEntryPopupComponent, {
      data: { action: PopupAction.New, item: {} }
    });
    () => {
      this.matDialog.closeAll();
    };
  }

  openUpdateStructureListEntryPopup(item: StructureListEntryDto): void {
    this.matDialog.open(StructureListEntryPopupComponent, {
      data: { action: PopupAction.Edit, item }
    });
    () => {
      this.matDialog.closeAll();
    };
  }

  openDeleteStructureListEntryPopup(item: StructureListEntryDto): void {
    this.matDialog.open(StructureListEntryPopupComponent, {
      data: { action: PopupAction.Delete, item }
    });
    () => {
      this.matDialog.closeAll();
    };
  }
}
